import * as React from "react";
import cx from "classnames";

import type { BaseFieldProps } from "./types";

export interface IconFieldProps extends BaseFieldProps {
  className?: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  placeholder?: string;
  type?: "text" | "email";
  value?: React.InputHTMLAttributes<HTMLInputElement>["value"];
  defaultValue?: React.InputHTMLAttributes<HTMLInputElement>["defaultValue"];
}

export const IconField: React.FC<IconFieldProps> = ({
  className,
  icon: Icon,
  onChange,
  onBlur,
  name,
  id,
  placeholder,
  label,
  type,
  error,
  touched = false,
  ...rest
}) => {
  id = id || name;

  return (
    <div className={cx("form-group", className)}>
      <label className="text-left" htmlFor={id}>
        {label}
      </label>
      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id={`${id}-addon`}>
            <Icon width={18} height={18} />
          </span>
        </div>
        <input
          id={id}
          name={name}
          type={type}
          className={cx("form-control", {
            "is-invalid": error && touched,
          })}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          {...rest}
        />
      </div>
      {error && touched && (
        <div className="invalid-feedback d-block">{error}</div>
      )}
    </div>
  );
};
